module.exports = __webpack_public_path__ + "img/Y2K-kv2.ac707047.jpg";